document.addEventListener('DOMContentLoaded', () => {
    const cmsToolbar = document.querySelector('#cms-top')
    if (cmsToolbar) {
        const mainHeader = document.querySelector('.main-header')
        if (mainHeader) {
            mainHeader.style.top = '46px'
        }

        const anchorLines = document.querySelector('.anchor-lines')
        window.addEventListener('scroll', () => {
            if (anchorLines && mainHeader.classList.contains('scroll-up')) {
                anchorLines.style.top = '126px'
            }

            if (anchorLines && mainHeader.classList.contains('scroll-down')) {
                anchorLines.style.top = '46px'
            }
        })
    }
})
